import { useState } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import {
  deleteTask as deleteTaskApi,
  fetchTasks,
} from 'src/models/timeclock/task/task';
import api from 'src/utils/ajax';
import toast from 'src/utils/toast';
import { useListSearchParams } from 'src/utils/useListSearchParams';

export const useTasks = () => {
  const [taskToEdit, setTaskToEdit] = useState<any>();
  const { params, updateParam } = useListSearchParams({
    paramPrefix: 'tasks_',
  });
  const page = params.page;
  const itemsPerPage = 5;

  const { data: taskData, isLoading } = useQuery({
    queryKey: ['tasks', page],

    queryFn: () => fetchTasks({ page, per: itemsPerPage }),
  });

  const { data: allTaskData } = useQuery({
    queryKey: ['tasks', 'all'],

    queryFn: () => fetchTasks({ fetchAll: true }),
  });

  const queryClient = useQueryClient();

  const handleDeleteTask = async (task: any) => {
    try {
      await deleteTaskApi(task);
      queryClient.invalidateQueries({
        queryKey: ['tasks'],
      });
      toast.success('Task deleted successfully');
    } catch (error) {
      toast.error(api.formatError(error, 'Failed to delete task'));
    }
  };

  return {
    paginatedTasks: taskData?.tasks || [],
    tasks: allTaskData?.tasks || [],
    totalTasks: taskData?.total || 0,
    tasksLoading: isLoading,
    deleteTask: handleDeleteTask,
    taskToEdit,
    setTaskToEdit,
    page,
    itemsPerPage,
    params,
    updateParam,
  };
};
